import { DATA_SOURCES } from '@/config/constants';
import { useEntities, useTikTokDataPoints } from 'utils/hooks/api';
import GraphNav from './GraphNav';
import { TIKTOK_SORT_OPTIONS } from 'utils/metrics';
import { useTikTokWeeks } from 'utils/hooks';

const defaultSortOptions = [
    TIKTOK_SORT_OPTIONS.non_cum_avg_weekly_views,
    TIKTOK_SORT_OPTIONS.non_cum_increase_WoW,
    TIKTOK_SORT_OPTIONS.non_cum_WoW,
    TIKTOK_SORT_OPTIONS.non_cum_increase_MoM_rolling,
    TIKTOK_SORT_OPTIONS.non_cum_MoM_rolling,
    TIKTOK_SORT_OPTIONS.non_cum_increase_QoQ_rolling,
    TIKTOK_SORT_OPTIONS.non_cum_QoQ_rolling,
    TIKTOK_SORT_OPTIONS.non_cum_increase_YoY_rolling,
    TIKTOK_SORT_OPTIONS.non_cum_YoY_rolling,
];

function TikTokGraphNav({ ids, countryId, categoryId, ...restProps }) {
    const categoriesQuery = useEntities({
        enabled: !!ids,
        ids,
        entityType: 'categories',
        dataSource: DATA_SOURCES.TIKTOK,
    });
    const categories = categoriesQuery.data?.reduce((acc, category) => {
        acc[category.id] = category;
        return acc;
    }, {});
    const { week, year } = useTikTokWeeks();
    const dataQueries = useTikTokDataPoints({
        enabled: !!(ids && week && year && countryId),
        countries: countryId ? [countryId] : null,
        categories: ids,
        week,
        year,
    });

    const data = dataQueries.reduce((acc, { data }) => {
        if (data?.data)
            acc.push(
                ...data.data.reduce((acc, { category, ...data }) => {
                    const maybeCategory = categories?.[category];
                    if (maybeCategory)
                        acc.push({
                            ...data,
                            id: category,
                            type: maybeCategory?.type,
                            label: maybeCategory?.label,
                            name: maybeCategory?.name,
                            fetching: categoriesQuery.isLoading,
                        });
                    return acc;
                }, []),
            );
        return acc;
    }, []);

    const isLoading =
        categoriesQuery.isLoading ||
        dataQueries.some(({ isLoading }) => isLoading) ||
        !ids.length;

    return (
        <GraphNav
            {...restProps}
            data={data}
            isLoading={isLoading}
            sortOptions={defaultSortOptions}
            primaryMetric={defaultSortOptions[0]}
            defaultSecondaryMetric={TIKTOK_SORT_OPTIONS.non_cum_YoY_rolling}
            week={week}
            year={year}
            categoryId={categoryId}
        />
    );
}

export default TikTokGraphNav;
